module.exports = __webpack_public_path__ + "static/media/immolation.13891ac4.png";